import { render } from "./StudentVocNirvanaItem.vue?vue&type=template&id=b7239b30&scoped=true"
import script from "./StudentVocNirvanaItem.vue?vue&type=script&lang=js"
export * from "./StudentVocNirvanaItem.vue?vue&type=script&lang=js"

import "./StudentVocNirvanaItem.vue?vue&type=style&index=0&id=b7239b30&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7239b30"]])

export default __exports__